import { Link } from "react-router-dom";

const EcomSolutionComponent = () => {
  return (
    <div className="flex flex-col justify-center items-center sm:mb-[1.5rem]">
      <div className="px-1 flex flex-col justify-center items-center sm:mb-5 ">
        <h1 className="react-reveal font-bold sm:text-4xl text-3xl sm:pt-[4rem] pt-[40px] pb-[0.7rem] text-[#373737]">
          E-com Solutions
        </h1>
        <hr className="react-reveal hr" />
        <p className="react-reveal text-sm text-center lg:max-w-[60rem] md:w-[41rem] mt-[0.6rem] mb-[1.7rem]">
          Increase the productivity of your business applications by integrating
          them with TCS products and services through APIs.
        </p>
        <div className="lg:flex md:grid flex-1  justify-center items-center ">
          <div className="lg:px-10 md:px-3 flex flex-col justify-center items-center">
            <img
              src="/Home/tcsdeveloperportal.svg"
              alt=""
              className="react-reveal h-20"
            />
            <h1 className="font-bold text-3xl pt-[1rem] text-[#373737]">
              TCS Developer Portal
            </h1>
            <p className="react-reveal text-sm text-md text-center lg:max-w-[25rem] md:w-[30rem] mt-[1rem] mb-[1.5rem] sm:w-[37rem]">
              Our Developer Portal allows the developers to augment their
              applications by integrating them with TCS APIs.
            </p>
            <button className="react-reveal moreBtn mb-[3rem] transition-all duration-500 gradientbg">
              <a href="https://sandbox.tcscourier.com/" target="_blank">
                More Details
              </a>
            </button>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:px-1">
            <img
              src="/Home/tcsplugins.svg"
              alt=""
              className="react-reveal h-20"
            />
            <h1 className="font-bold text-3xl pt-[1rem] text-[#373737]">
              TCS Plug-ins
            </h1>
            <p className="react-reveal text-sm text-md text-center lg:max-w-[25rem] md:w-[30rem] mt-[1rem] mb-[1.5rem] sm:w-[37rem]">
              Our plug-ins allows you to add specific features to your existing
              business applications — whether your own or third-party — by
              adding customisations and additional functionalities to suit your
              purpose.
            </p>
            <button className="react-reveal moreBtn mb-[3rem] transition-all duration-500 gradientbg">
              <a href="/plugins">More Details</a>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EcomSolutionComponent;
